import React, { useEffect, useState } from "react";
import {
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  Button,
} from "@mui/material";
import styles from "./splitConfig.module.css";
import { useAllProduct } from "../../../../api-context/commonApiContext";
import config from "../../../../service/config";
import FullScreenLoader from "../../../../reusable/loader/FullScreenLoader";

const SplitConfig = ({ selectedEscrow }) => {
  console.log("selectedEscrow", selectedEscrow);

  const {
    filterEscrowVal,
    clientId,
    loading,
    setLoading,
    selectedCompanyName,
    userId,
  } = useAllProduct();

  const [type, setType] = useState("Percentage");
  const [numberOfSplits, setNumberOfSplits] = useState(0);
  const [splits, setSplits] = useState(
    Array(0)
      .fill(null)
      .map(() => ({ escrowId: "", value: "" }))
  );

  const [swipeOutConfigs, setSwipeOutConfigs] = useState([
    {
      subEscrowId: "",
      beneficiaryId: "",
      reserveBalance: "",
      reserveFrequency: "Time period",
      reserveTimePeriod: "Day",
      reserveValue: "",
      mode: "",
    },
  ]);

  const [swipeOut, setSwipeOut] = useState(false);

  const [frequencyValue, setFrequencyValue] = useState("");
  const [frequencyType, setFrequencyType] = useState("Time period");
  const [selectedTimePeriod, setSelectedTimePeriod] = useState("Day");

  const [reserveBalance, setReserveBalance] = useState("");
  const [reserveFrequency, setReserveFrequency] = useState("Time period");
  const [reserveTimePeriod, setReserveTimePeriod] = useState("Day");
  const [reserveValue, setReserveValue] = useState("");
  const [subEscrowList, setSubEscrowList] = useState([]);
  const [beneficiaryList, setBeneficiaryList] = useState([]);
  // useEffect(() => {
  //   if (selectedEscrow?.split_config) {
  //     const config = selectedEscrow.split_config;

  //     setType(config.type || "Percentage");
  //     setNumberOfSplits(config.number_of_splits || 4);
  //     setSplits(
  //       (config.splits || []).map((s) => ({
  //         escrowId: s.escrowId || "",
  //         value: s.value || "",
  //       }))
  //     );
  //     setSwipeOut(config.swipe_out ?? true);
  //     setFrequencyValue(config.frequency_value || "");
  //     setFrequencyType(config.frequency_type || "Time period");
  //     setSelectedTimePeriod(config.time_period || "Day");
  //     setReserveBalance(config.reserve_balance || "");
  //     setReserveFrequency(config.reserve_frequency || "Time period");
  //     setReserveTimePeriod(config.reserve_time_period || "Day");
  //     setReserveValue(config.reserve_value || "");
  //   }
  // }, [selectedEscrow]);

  useEffect(() => {
    const fetchBeneficiaries = async () => {
      try {
        setLoading(true);

        const res = await fetch(
          `${
            config.node_api_endpoint
          }/api/beneficiaries?createdByUserId=${userId}&clientId=${clientId.trim()}&selectedCompanyName=${selectedEscrow.registered_company_name.trim()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
          }
        );

        const result = await res.json();
        console.log("result", result);

        if (result.success) {
          const flatList = result.data.flatMap((block) => {
            console.log("companyBlock", block);
            const companyBlock =
              block[selectedEscrow.registered_company_name.trim()];
            return companyBlock?.entries || [];
          });

          setBeneficiaryList(flatList.sort((a, b) => b.id - a.id));
        } else {
          console.error("Error fetching beneficiaries:", result.message);
        }
      } catch (error) {
        console.error("API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBeneficiaries();
  }, [selectedCompanyName]);

  useEffect(() => {
    if (!clientId) return;
    setLoading(true);
    fetch(
      `${
        config.node_api_endpoint
      }/api/sub-escrow?client_id=${clientId}&company_name=${encodeURIComponent(
        selectedEscrow?.registered_company_name
      )}&main_escrowid=${selectedEscrow?.main_escrow_id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
        },
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch sub_escrow");
        }
        return res.json();
      })
      .then((data) => {
        if (data.success) {
          setSubEscrowList(data.sub_escrow || []);
        } else {
          setSubEscrowList([]);
        }
      })
      .catch((err) => {
        console.error("API error:", err);
        setSubEscrowList([]);
      })
      .finally(() => {
        setLoading(false); // ✅ End loader
      });
  }, []);

  // ✅ Populate all split config state including swipeOut and swipeOutConfigs
  useEffect(() => {
    if (selectedEscrow?.split_config) {
      const config = selectedEscrow.split_config;

      setType(config.type || "Percentage");

      let splitsCount = config.number_of_splits || 4;

      if (subEscrowList.length > 0 && splitsCount > subEscrowList.length) {
        splitsCount = subEscrowList.length;
      }

      setNumberOfSplits(splitsCount);
      setSplits(
        config.splits?.length > 0
          ? config.splits.map((s) => ({
              escrowId: s.escrowId || "",
              value: s.value || "",
            }))
          : Array(splitsCount)
              .fill(null)
              .map(() => ({ escrowId: "", value: "" }))
      );

      // rest unchanged...
      setFrequencyValue(config.frequency_value || "");
      setFrequencyType(config.frequency_type || "Time period");
      setSelectedTimePeriod(config.time_period || "Day");
      setSwipeOut(!!config.swipe_out);
      setSwipeOutConfigs(
        config.swipe_out && config.swipe_out_configs?.length > 0
          ? config.swipe_out_configs
          : config.swipe_out
          ? [
              {
                subEscrowId: "",
                beneficiaryId: "",
                reserveBalance: "",
                reserveFrequency: "Time period",
                reserveTimePeriod: "Day",
                reserveValue: "",
                mode: "",
              },
            ]
          : []
      );
    }
  }, [selectedEscrow, subEscrowList]);

  // const handleSplitChange = (index, field, value) => {
  //   const updated = [...splits];
  //   updated[index][field] = value;
  //   setSplits(updated);
  // };

  const handleSplitChange = (index, field, value) => {
    const updated = [...splits];

    // Allow input only if it's a valid number
    if (field === "value" && isNaN(value)) return;

    // Temporarily update the value for validation
    updated[index][field] = value;

    // Validate total percentage if type is Percentage
    if (type === "Percentage" && field === "value") {
      const total = updated.reduce((sum, item, i) => {
        const val = parseFloat(item.value);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);

      if (total > 100) {
        alert("Total percentage cannot exceed 100%");
        return;
      }
    }

    setSplits(updated);
  };

  const handleSave = () => {
    const payload = {
      client_id: selectedEscrow.client_id,
      main_escrow_id: selectedEscrow.main_escrow_id,
      split_config: {
        type,
        number_of_splits: numberOfSplits,
        splits,
        frequency_type: frequencyType,
        time_period: selectedTimePeriod,
        frequency_value: frequencyValue,
        swipe_out: swipeOut,
        swipe_out_configs: swipeOut ? swipeOutConfigs : [],
      },
    };

    console.log("Saving split config:", payload); // ✅ clear log
    setLoading(true);
    fetch("http://localhost:3002/api/escrow-split-config", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          alert("Split configuration saved successfully!");
        } else {
          alert(result.message);
        }
      })
      .catch((error) => {
        console.error("Failed to save split config:", error);
        alert("Something went wrong");
      })
      .finally(() => {
        setLoading(false); // ✅ End loader
      });
  };
  console.log("subEscrowList", beneficiaryList);
  return (
    <>
      <FullScreenLoader spinning={loading} />
      <div className={styles.container}>
        <div className={styles.row}>
          <div>
            <div style={{ fontWeight: "600" }} className="mb-2">
              {"Select type"}
            </div>
            <FormControl
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0 !important",
                },
                width: "250px",
              }}
            >
              {/* <InputLabel>Select type</InputLabel> */}
              <Select
                value={type}
                onChange={(e) => setType(e.target.value)}
                // label="Select type"
              >
                <MenuItem value="Percentage">Percentage</MenuItem>
                <MenuItem value="Value">Value</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div>
            <div style={{ fontWeight: "600" }} className="mb-2">
              {"Select number of splits"}
            </div>
            <TextField
              type="number"
              value={numberOfSplits}
              onChange={(e) => {
                const newCount = parseInt(e.target.value, 10);

                if (newCount > subEscrowList.length) {
                  alert(
                    "Number of splits cannot exceed available Sub Escrow IDs."
                  );
                  return;
                }

                if (!isNaN(newCount) && newCount >= 0) {
                  setNumberOfSplits(newCount);

                  if (splits.length >= newCount) {
                    setSplits(splits.slice(0, newCount));
                  } else {
                    setSplits([
                      ...splits,
                      ...Array(newCount - splits.length)
                        .fill(null)
                        .map(() => ({ escrowId: "", value: "" })),
                    ]);
                  }
                } else {
                  setNumberOfSplits("");
                  setSplits([]);
                }
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0 !important",
                },
                width: "250px",
              }}
            />
          </div>
        </div>

        <div className={styles.escrowGrid}>
          {splits.map((item, idx) => (
            <div className={styles.escrowBlock} key={idx}>
              <Typography sx={{ fontWeight: 500, marginBottom: 1 }}>
                Escrow Id {idx + 1} <span style={{ color: "#DC3545" }}>*</span>
              </Typography>
              <div className={styles.escrowPair}>
                <FormControl
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0 !important",
                    },
                    width: "50%",
                  }}
                >
                  <Select
                    value={item.escrowId}
                    onChange={(e) =>
                      handleSplitChange(idx, "escrowId", e.target.value)
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Escrow ID
                    </MenuItem>
                    {subEscrowList
                      .filter(
                        (id) =>
                          !splits.some((s, i) => i !== idx && s.escrowId === id)
                      )
                      .map((escrowId) => (
                        <MenuItem key={escrowId} value={escrowId.id}>
                          {escrowId.id}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <TextField
                  placeholder="Enter Value"
                  value={item.value}
                  onChange={(e) =>
                    handleSplitChange(idx, "value", e.target.value)
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {type === "Percentage" ? "%" : "₹"}
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0 !important",
                    },
                    width: "50%",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        {
          /* swipeOut === false && */ <>
            {" "}
            <hr />
            <Typography sx={{ fontWeight: 500 }}>Set Frequency</Typography>
            <div className={styles.row}>
              <RadioGroup
                row
                value={frequencyType}
                onChange={(e) => setFrequencyType(e.target.value)}
              >
                <FormControlLabel
                  value="Time period"
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#2348AB",
                        },
                      }}
                    />
                  }
                  label="Time period"
                />
                {/* <FormControlLabel
            value="Unit"
            control={
              <Radio
                sx={{
                  "&.Mui-checked": {
                    color: "#2348AB",
                  },
                }}
              />
            }
            label="Unit"
          /> */}
                <FormControlLabel
                  value="Calendar day"
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#2348AB",
                        },
                      }}
                    />
                  }
                  label="Calendar day"
                />
              </RadioGroup>
            </div>
            <div className="d-flex gap-2">
              {/* Time Period: Dropdown + Input */}
              {frequencyType === "Time period" && (
                <>
                  <div className={`w-25 ${styles.dropdownWrapper}`}>
                    <label
                      htmlFor="timePeriodSelect"
                      className={styles.dropdownLabel}
                    >
                      If selected time period*
                    </label>
                    <select
                      id="timePeriodSelect"
                      value={selectedTimePeriod}
                      onChange={(e) => {
                        setSelectedTimePeriod(e.target.value);
                        setFrequencyValue(""); // reset frequencyValue on period change
                      }}
                      style={{ borderRadius: 0 }}
                      className={styles.customSelect}
                    >
                      <option value="Minute">Minute</option>
                      <option value="hour">hour</option>
                      <option value="Day">Day</option>
                    </select>
                  </div>

                  <div className={`w-25 ${styles.dropdownWrapper}`}>
                    <label
                      htmlFor="timePeriodInput"
                      className={styles.dropdownLabel}
                    >
                      Enter Value*
                    </label>

                    {selectedTimePeriod === "Minute" && (
                      <select
                        id="timePeriodInput"
                        style={{ borderRadius: 0 }}
                        className={styles.customSelect}
                        value={frequencyValue}
                        onChange={(e) => setFrequencyValue(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="15">15</option>
                        <option value="30">30</option>
                        <option value="45">45</option>
                      </select>
                    )}

                    {selectedTimePeriod === "hour" && (
                      <select
                        id="timePeriodInput"
                        style={{ borderRadius: 0 }}
                        className={styles.customSelect}
                        value={frequencyValue}
                        onChange={(e) => setFrequencyValue(e.target.value)}
                      >
                        <option value="">Select</option>
                        {Array.from({ length: 23 }, (_, i) => i + 1).map(
                          (val) => (
                            <option key={val} value={val}>
                              {val}
                            </option>
                          )
                        )}
                      </select>
                    )}

                    {selectedTimePeriod === "Day" && (
                      <select
                        id="timePeriodInput"
                        style={{ borderRadius: 0 }}
                        className={styles.customSelect}
                        value={frequencyValue}
                        onChange={(e) => setFrequencyValue(e.target.value)}
                      >
                        <option value="">Select</option>
                        {Array.from({ length: 30 }, (_, i) => i + 1).map(
                          (val) => (
                            <option key={val} value={val}>
                              {val}
                            </option>
                          )
                        )}
                      </select>
                    )}

                    {!["Minute", "hour", "Day"].includes(
                      selectedTimePeriod
                    ) && (
                      <input
                        type="text"
                        style={{ borderRadius: 0 }}
                        id="timePeriodInput"
                        value={frequencyValue}
                        onChange={(e) => setFrequencyValue(e.target.value)}
                        className={styles.customSelect}
                        placeholder="Enter Value"
                      />
                    )}
                  </div>
                </>
              )}

              {/* Unit: Only input */}
              {frequencyType === "Unit" && (
                <div className={`w-25 ${styles.dropdownWrapper}`}>
                  <label htmlFor="unitInput" className={styles.dropdownLabel}>
                    Enter Value*
                  </label>
                  <input
                    type="text"
                    style={{ borderRadius: 0 }}
                    id="unitInput"
                    value={frequencyValue}
                    onChange={(e) => setFrequencyValue(e.target.value)}
                    className={styles.customSelect}
                    placeholder="Enter Value"
                  />
                </div>
              )}

              {/* Calendar Day: Only dropdown 1–20 */}
              {frequencyType === "Calendar day" && (
                <div className={`w-25 ${styles.dropdownWrapper}`}>
                  <label
                    htmlFor="calendarDaySelect"
                    className={styles.dropdownLabel}
                  >
                    Select Value*
                  </label>
                  <select
                    style={{ borderRadius: 0 }}
                    id="calendarDaySelect"
                    value={reserveValue}
                    onChange={(e) => setReserveValue(e.target.value)}
                    className={styles.customSelect}
                  >
                    <option value="">Select</option>
                    {Array.from({ length: 28 }, (_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                    <option value={29}>{"Last day of the month"}</option>
                  </select>
                </div>
              )}
            </div>
          </>
        }
        <hr />
        <FormControlLabel
          label="Swipe out"
          // labelPlacement="start"
          control={
            <Switch
              checked={swipeOut}
              onChange={() => {
                if (!swipeOut) {
                  // turning ON: ensure at least one config exists
                  if (swipeOutConfigs.length === 0) {
                    setSwipeOutConfigs([
                      {
                        subEscrowId: "",
                        reserveBalance: "",
                        reserveFrequency: "Time period",
                        reserveTimePeriod: "Day",
                        reserveValue: "",
                        mode: "",
                      },
                    ]);
                  }
                } else {
                  // turning OFF: clear configs
                  setSwipeOutConfigs([]);
                }
                setSwipeOut(!swipeOut);
              }}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": { color: "#ffffff" },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#2348AB",
                },
              }}
            />
          }
        />

        {swipeOut && swipeOutConfigs.length > 0 && (
          <div
            style={{
              border: "1px solid #ccc",
              padding: "16px",
              marginBottom: "16px",
            }}
          >
            {swipeOutConfigs.map((config, idx) => (
              <div
                key={idx}
                style={{
                  border: "1px dashed #aaa",
                  padding: "12px",
                  marginBottom: "16px",
                  position: "relative",
                }}
              >
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  sx={{ position: "absolute", top: 8, right: 8 }}
                  onClick={() => {
                    const updated = swipeOutConfigs.filter((_, i) => i !== idx);
                    setSwipeOutConfigs(updated);
                  }}
                >
                  Remove
                </Button>
                <Typography className={styles.dropdownLabel}>
                  Select Sub Escrow {/* ({idx + 1}) */}
                </Typography>
                <FormControl
                  sx={{
                    width: "250px",
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 0,
                    },
                  }}
                >
                  <Select
                    displayEmpty
                    value={config.subEscrowId}
                    onChange={(e) => {
                      const updated = [...swipeOutConfigs];
                      updated[idx].subEscrowId = e.target.value;
                      setSwipeOutConfigs(updated);
                    }}
                    sx={{ "& fieldset": { borderRadius: 0 } }}
                  >
                    <MenuItem value="">
                      <em>Select Sub Escrow</em>
                    </MenuItem>
                    {subEscrowList
                      .filter((se) => se.status === "Active")
                      .map((se) => (
                        <MenuItem key={se.id} value={se.id}>
                          {se.id}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <Typography className={styles.dropdownLabel}>
                  Set Reserve Balance
                </Typography>
                <TextField
                  placeholder="Enter Value"
                  value={config.reserveBalance}
                  onChange={(e) => {
                    const updated = [...swipeOutConfigs];
                    updated[idx].reserveBalance = e.target.value;
                    setSwipeOutConfigs(updated);
                  }}
                  sx={{
                    "& fieldset": { borderRadius: 0 },
                    width: "250px",
                    mb: 2,
                  }}
                />

                {/* Frequency */}
                <Typography className={styles.dropdownLabel}>
                  Set Frequency
                </Typography>
                <RadioGroup
                  row
                  value={config.reserveFrequency}
                  onChange={(e) => {
                    const updated = [...swipeOutConfigs];
                    updated[idx].reserveFrequency = e.target.value;
                    updated[idx].reserveTimePeriod = "Day";
                    updated[idx].reserveValue = "";
                    setSwipeOutConfigs(updated);
                  }}
                >
                  <FormControlLabel
                    value="Time period"
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: "#2348AB",
                          },
                        }}
                      />
                    }
                    label="Time period"
                  />
                  <FormControlLabel
                    value="Calendar day"
                    control={
                      <Radio
                        sx={{
                          "&.Mui-checked": {
                            color: "#2348AB",
                          },
                        }}
                      />
                    }
                    label="Calendar day"
                  />
                </RadioGroup>

                <div className="d-flex gap-2">
                  {/* Time Period: Dropdown + Input */}
                  {config.reserveFrequency === "Time period" && (
                    <>
                      <div className={`w-25 ${styles.dropdownWrapper}`}>
                        <label className={styles.dropdownLabel}>
                          If selected time period*
                        </label>
                        <select
                          value={config.reserveTimePeriod}
                          onChange={(e) => {
                            const updated = [...swipeOutConfigs];
                            updated[idx].reserveTimePeriod = e.target.value;
                            updated[idx].reserveValue = ""; // reset on change
                            setSwipeOutConfigs(updated);
                          }}
                          className={styles.customSelect}
                          style={{ borderRadius: 0 }}
                        >
                          <option value="Minute">Minute</option>
                          <option value="hour">hour</option>
                          <option value="Day">Day</option>
                        </select>
                      </div>

                      <div className={`w-25 ${styles.dropdownWrapper}`}>
                        <label className={styles.dropdownLabel}>
                          Enter Value*
                        </label>

                        {config.reserveTimePeriod === "Minute" && (
                          <select
                            className={styles.customSelect}
                            style={{ borderRadius: 0 }}
                            value={config.reserveValue}
                            onChange={(e) => {
                              const updated = [...swipeOutConfigs];
                              updated[idx].reserveValue = e.target.value;
                              setSwipeOutConfigs(updated);
                            }}
                          >
                            <option value="">Select</option>
                            <option value="15">15</option>
                            <option value="30">30</option>
                            <option value="45">45</option>
                          </select>
                        )}

                        {config.reserveTimePeriod === "hour" && (
                          <select
                            className={styles.customSelect}
                            style={{ borderRadius: 0 }}
                            value={config.reserveValue}
                            onChange={(e) => {
                              const updated = [...swipeOutConfigs];
                              updated[idx].reserveValue = e.target.value;
                              setSwipeOutConfigs(updated);
                            }}
                          >
                            <option value="">Select</option>
                            {Array.from({ length: 23 }, (_, i) => i + 1).map(
                              (val) => (
                                <option key={val} value={val}>
                                  {val}
                                </option>
                              )
                            )}
                          </select>
                        )}

                        {config.reserveTimePeriod === "Day" && (
                          <select
                            className={styles.customSelect}
                            style={{ borderRadius: 0 }}
                            value={config.reserveValue}
                            onChange={(e) => {
                              const updated = [...swipeOutConfigs];
                              updated[idx].reserveValue = e.target.value;
                              setSwipeOutConfigs(updated);
                            }}
                          >
                            <option value="">Select</option>
                            {Array.from({ length: 30 }, (_, i) => i + 1).map(
                              (val) => (
                                <option key={val} value={val}>
                                  {val}
                                </option>
                              )
                            )}
                          </select>
                        )}
                      </div>
                    </>
                  )}

                  {/* Calendar Day */}
                  {config.reserveFrequency === "Calendar day" && (
                    <div className={`w-25 ${styles.dropdownWrapper}`}>
                      <label className={styles.dropdownLabel}>
                        Select Value*
                      </label>
                      <select
                        className={styles.customSelect}
                        style={{ borderRadius: 0 }}
                        value={config.reserveValue}
                        onChange={(e) => {
                          const updated = [...swipeOutConfigs];
                          updated[idx].reserveValue = e.target.value;
                          setSwipeOutConfigs(updated);
                        }}
                      >
                        <option value="">Select</option>
                        {Array.from({ length: 28 }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                        <option value={29}>Last day of the month</option>
                      </select>
                    </div>
                  )}
                </div>

                {/* Mode */}
                <div className={`w-25 ${styles.dropdownWrapper} mt-2`}>
                  <label className={styles.dropdownLabel}>Select Mode</label>
                  <select
                    value={config.mode}
                    onChange={(e) => {
                      const updated = [...swipeOutConfigs];
                      updated[idx].mode = e.target.value;
                      setSwipeOutConfigs(updated);
                    }}
                    className={styles.customSelect}
                  >
                    <option value="">Select</option>
                    <option value="NEFT">NEFT</option>
                    <option value="IMPS">IMPS</option>
                    <option value="RTGS">RTGS</option>
                    <option value="FT">FT</option>
                  </select>
                </div>

                {/* Beneficiary */}
                <Typography className={`${styles.dropdownLabel} mt-2`}>
                  Select Beneficiary
                </Typography>
                <FormControl sx={{ width: "250px", mb: 2 }}>
                  <Select
                    displayEmpty
                    value={config.beneficiaryId}
                    onChange={(e) => {
                      const updated = [...swipeOutConfigs];
                      updated[idx].beneficiaryId = e.target.value;
                      setSwipeOutConfigs(updated);
                    }}
                    sx={{
                      "& fieldset": { borderRadius: 0 },
                    }}
                  >
                    <MenuItem value="">
                      <em>Select Beneficiary</em>
                    </MenuItem>
                    {beneficiaryList?.map((b) => (
                      <MenuItem value={b.name}>{b.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            ))}

            {/* ADD button */}
            <Button
              variant="outlined"
              sx={{ width: 120, color: "#FFFFFF", backgroundColor: "#2348AB" }}
              onClick={() =>
                setSwipeOutConfigs([
                  ...swipeOutConfigs,
                  {
                    subEscrowId: "",
                    beneficiaryId: "",
                    reserveBalance: "",
                    reserveFrequency: "Time period",
                    reserveTimePeriod: "Day",
                    reserveValue: "",
                    mode: "",
                  },
                ])
              }
            >
              + Add
            </Button>
          </div>
        )}

        <Button
          variant="contained"
          sx={{ width: 120, color: "#FFFFFF", backgroundColor: "#2348AB" }}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default SplitConfig;
